var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.172 0L0 1.172 8.854 10 0 18.828 1.172 20l8.88-8.828L18.906 20l1.172-1.172L11.224 10l8.854-8.828L18.906 0l-8.854 8.828L1.172 0z",
    fill: "#8FA0A4"
  })));
}
export default SvgCloseLarge;